module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/package/package.component.css
// module id = ./src/app/components/package/package.component.css
// module chunks = main